import logFactory from 'c9-js-log-client';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './root-reducer';
import { createLoggingAndTrackingMiddleware } from 'migration-flos-react';

const composeEnhancers =
    typeof window === 'object' && window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']
        ? window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']({})
        : compose;

const configureStore = (config) =>
    createStore(
        rootReducer,
        composeEnhancers(
            applyMiddleware(
                thunk,
                createLoggingAndTrackingMiddleware({
                    logger: logFactory(config.endpoints.log, config.appId, config.logLevel, config.defaultCategory),
                    tracker: config.trackingHandler
                })
            )
        )
    );

export default configureStore;
